import { Input, Select } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getThread } from "../redux/selectors";
import { fabrics } from "../scripts/fabrics";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import ExpertModal from "../components/modals/expertModal";
import TonalStatistic from "../components/TonalStatisticSmall";

const Thread = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState({});
  const [factories, setFactories] = useState(fabrics);
  const thread = useSelector(getThread);
  const closeModal = (value: any) => {
    setModalOpen(false);
  };
  let type = localStorage.getItem("usertype");

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log(event.target.value);
    setFactories(
      fabrics.filter((fabric) =>
        fabric.title.toUpperCase().includes(event.target.value.toUpperCase())
      )
    );
  };

  let netOptions: any = [];
  if (thread?.networks?.includes(1))
    netOptions.push({ value: "vk", label: "ВКонтакте" });
  if (thread?.networks?.includes(2))
    netOptions.push({ value: "tw", label: "Twitter" });
  if (thread?.networks?.includes(3))
    netOptions.push({ value: "fb", label: "Facebook" });
  if (thread?.networks?.includes(5))
    netOptions.push({ value: "tg", label: "Telegram" });
  if (thread?.networks?.includes(7))
    netOptions.push({ value: "ig", label: "Instagram" });
  if (thread?.networks?.includes(8))
    netOptions.push({ value: "yt", label: "Youtube" });
  if (thread?.networks?.includes(10))
    netOptions.push({ value: "ok", label: "Одноклассники" });
  if (thread?.networks?.includes(11))
    netOptions.push({ value: "dz", label: "Дзен" });
  if (thread?.networks?.includes(4))
    netOptions.push({ value: "smi", label: "СМИ" });

  return (
    <div className="App">
      {/*      <div className='btn-group'>
        {fabrics?.map((competitor: any, id) => (
          <Button
            key={id}
            onClick={() => {
              setCurrent(id)
              navigate(`/factory/${id}`)
            }}
          >
            {competitor?.title}
          </Button>
        ))}
      </div>*/}

      <div className="white-block">
        <Input
          addonBefore={<SearchOutlined />}
          placeholder="Поиск"
          style={{ width: 200 }}
          onChange={handleSearch}
        />
        {"   "}
        <Select
          style={{ width: 200 }}
          allowClear={false}
          options={[
            { value: "металлургия" },
            { value: "машиностроение" },
            { value: "нефтеперерабатывающая" },
            { value: "химическая" },
            { value: "лесопромышленный комплекс" },
            { value: "целлюлозно-бумажная" },
            { value: "строительных материалов" },
            { value: "электроэнергетика" },
            { value: "агропромышленный комплекс" },
            { value: "пищевая" },
            { value: "легкая" },
          ]}
          placeholder="Отрасль"
          showSearch
        />
        <div className="flex-space margin-bottom"></div>
        {loading ? (
          <div className="feed-posts-loader">
            <LoadingOutlined />
          </div>
        ) : (
          <div className="grid3">
            {factories?.map((item: any, id: any) => (
              <div
                className="grid-block gray-block btn-cursor flex-self-end"
                key={id}
              >
                <div className="margin-bottom">
                  <div className="flex-space">
                    <p
                      className="title-small"
                      style={{ height: "60px", overflow: "hidden" }}
                      onClick={() => {
                        setCurrent(item);
                        navigate(`/factory/${id}`);
                      }}
                    >
                      {item?.title}
                    </p>
                    {type == "industry" && (
                      <img
                        src="/settings.png"
                        alt="Редактировать"
                        onClick={() => {
                          setModalOpen(true);
                          setCurrent(item);
                        }}
                      />
                    )}
                  </div>
                  {
                    <p>
                      Надежность <b>{item?.trusted}</b>
                    </p>
                  }

                  <TonalStatistic />
                </div>
                <ExpertModal
                  open={modalOpen}
                  isCloseModal={closeModal}
                  user={current}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Thread;
